<template>
  <div
    :class="[
      'form-control',
      disabled && 'form-control_disabled',
      required && 'form-control_required',
      hasErrors && 'form-control_error',
      theme && `form-control_theme_${theme}`,
    ]"
  >
    <label v-if="label" class="form-control__label">{{ label }}</label>
    <div class="form-control__input">
      <slot v-bind="{ hasErrors }"></slot>
    </div>
    <div v-if="hasErrors" class="form-control__errors">
      <template v-for="(error, index) in errors">
        <slot name="error" v-bind="{ error }">
          <div :key="index" class="form-control__error">{{ error }}</div>
        </slot>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormControl',

  props: {
    disabled: {
      default: false,
      type: Boolean,
    },

    errors: {
      default: () => [],
      type: Array,
    },

    label: {
      default: '',
      type: String,
    },

    required: {
      default: false,
      type: Boolean,
    },

    theme: {
      default: '',
      type: String,
    },
  },

  computed: {
    hasErrors() {
      return Array.isArray(this.errors) && this.errors.length > 0;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/tools/mixins';
@import '~styles/tools/variables';

.form-control {
  margin-bottom: 36px;

  &_required {
    .form-control__label {
      &::after {
        @include required-asterisk;
      }
    }
  }

  &__errors {
    margin-top: 0.5rem;
    color: $error-red;
  }

  &__label {
    font-size: 14px;
    color: $default-grey;
    margin-bottom: 10px;
    text-transform: uppercase;
    letter-spacing: 0.5px;

    .form-control_theme_dark & {
      color: white;

      &::after {
        color: white;
      }
    }

    .form-control_error & {
      &::after {
        color: $error-red;
      }
    }

    .form-control_disabled & {
      opacity: 0.25;
    }
  }
}
</style>
